<header>
  <div class="navbar navbar-top navbar-default nav-header-dashboard bg-celeste-argentina" role="navigation"
    aria-labelledby="Mi cuenta">
    <div class="nav navbar-nav navbar-header m-y-1 m-l-2">
      <a routerLink="/home" id="logo">
        <img src="../assets/images/argentinagob-2.svg" class="brand-icon" height="40">
        <h1 class="sr-only">Matriculacion</h1>
      </a>
    </div>
    <nav *ngIf="isLoggedIn && usuarioLogueado"
      class="dropdown nav navbar-nav navbar-right navbar-right-mobile navbar-right-header m-y-1">
      <button class="text-white btn dropdown-toggle m-t-0 m-r-2" type="button" id="dropdownMenuButton"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span>Mi cuenta </span>
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
      <div class="dropdown-menu dropdown-micuenta" aria-labelledby="dropdownMenuButton" role="dialog" aria-modal="true">
        <ul>
          <li>
            <p><strong>{{usuarioLogueado.nombre}} {{usuarioLogueado.apellido}}</strong></p>
          </li>
          <hr>
          <li role="menu-item" *ngIf="showAdmin"><a routerLink="/gestion-usuarios" class="logout clickeable">Gestión de Usuarios</a></li>
          <li role="menu-item"><a (click)="logout()" class="logout clickeable">Cerrar la sesión</a></li>
        </ul>
        <button class="btn btn-link no-border-shadow dropdown-toggle sr-only" type="button" id="dropdownMenuButton"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span class="sr-only">Cerrar menú mi cuenta</span>
          <i class="fa fa-chevron-up text-muted text-center visible-xs" aria-hidden="true"></i>
        </button>
      </div>
    </nav>
  </div>
</header>
<main role="main">
  <div *ngIf="spinnerGeneral">
    <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Cargando...</p>
    </ngx-spinner>
  </div>
  <router-outlet></router-outlet>
</main>
<footer class="main-footer bg-celeste-argentina">
  <div class="container-fluid">
    <div class="row sub-footer">
      <div class="container">
        <div class="col-sm-6 m-y-1 p-x-0">
          <img class="image-responsive" width="288" height="40"
            src="../assets/images/logo_argentina_unida-blanco.svg" />
          <p class="text-muted small m-b-2">
        </div>
      </div>
    </div>
  </div>
</footer>